<template>
  <div class="container main-container main-container--hygiene view">
    <div class="row">
      <div class="col-lg-24">
        <h2 class="h2 d-inline-block mb-lg-4 mr-1">
          {{ $t('Tell Us About Your Nutrition and Feeding Program') }}
        </h2>
        <modal-info :value="'nutrition'" class="d-inline">
          <template slot="modal-content">
            <h2 class="h2 pb-2 pt-3 px-3 text-center">
              {{ $t('Nutrition and Feeding') }}
            </h2>
            <p class="px-3">
              {{
                'For more information about Nutrition and Feeding, click the link to learn more from'
                  | translate
              }}
              <a
                :href="$t('https://library.zinprofirststep.com/nutrition/')"
                @click="$goToLameness($t('/nutrition/'), $event)"
                target="_blank"
                >{{ 'FirstStep Resources' | translate }}</a
              >.
            </p>
            <div class="row modal-bottom pb-3">
              <a
                href="#"
                class="btn-cancel-modal d-flex justify-content-center"
                data-dismiss="modal"
                >{{ $t('Cancel') }}</a
              >
            </div>
          </template>
        </modal-info>
      </div>
    </div>

    <hr class="mb-4 mt-1 mt-lg-0" />

    <div class="row align-items-end">
      <div class="col-24">
        <h2 class="h2 mb-lg-4">{{ $t('Feed Access') }}</h2>
      </div>
      <div class="col-lg-12 col-xl-8">
        <label class="mb-1">{{
          $t('Feed Space (') +
          $t($getEquivalentUnit(evaluation.data.measurements, 'cm')) +
          $t('/cow)')
        }}</label>
        <currency-input
          v-model="converted_feed_space"
          :options="{
            currency: 'USD',
            currencyDisplay: 'hidden',
            precision: { min: 0, max: 2 },
          }"
        />
      </div>
      <div class="col-lg-12 col-xl-8">
        <label class="mb-1">{{ $t('Percentage of Group Lying Down Chewing Cud') }}</label>
        <currency-input
          v-model="assessor.data.percentage_of_group_lying_down_chewing_cud"
          :options="{
            currency: 'USD',
            currencyDisplay: 'hidden',
            precision: { min: 0, max: 2 },
          }"
        />
      </div>
      <div class="col-lg-12 col-xl-8">
        <label class="mb-1">{{
          $t('What was the time relative to milking or feeding that cud chewing was assessed?')
        }}</label>
        <input
          type="text"
          v-model="assessor.data.time_of_lying_down_chewing_cud_assessment"
          class="form-control"
        />
      </div>
    </div>

    <hr class="mt-4" />

    <question-three
      @change="assessor.data.are_there_any_empty_feed_bunks_after_milking = $event.value"
      :initial-value="assessor.data.are_there_any_empty_feed_bunks_after_milking"
    >
      <label class="label d-inline-block">
        {{ $t('Are there any empty feed bunks after milking?') }}
      </label>
    </question-three>

    <hr />

    <question-three
      @change="
        assessor.data.are_grazing_cows_held_off_pasture_for_prolonged_periods_other_than_milking_time =
          $event.value
      "
      :initial-value="
        assessor.data
          .are_grazing_cows_held_off_pasture_for_prolonged_periods_other_than_milking_time
      "
    >
      <label class="label d-inline-block">
        {{
          $t(
            'Are grazing cows held off pasture for prolonged periods (> 1 hour) other than milking time?',
          )
        }}
      </label>
    </question-three>

    <hr class="mb-4" />

    <div class="row">
      <div class="col-24">
        <h2 class="h2 mb-lg-4">{{ $t('Risk of Acidosis') }}</h2>
      </div>
      <div class="col-lg-8">
        <label class="mb-1">{{ $t('Dry Matter %') }}</label>
        <currency-input
          v-model="assessor.data.dry_matter"
          :options="{
            currency: 'USD',
            currencyDisplay: 'hidden',
            precision: { min: 0, max: 2 },
          }"
        />
      </div>
      <div class="col-lg-8">
        <label class="mb-1">{{ $t('TMR Top Screen %') }}</label>
        <currency-input
          v-model="assessor.data.tmr_top_screen"
          :options="{
            currency: 'USD',
            currencyDisplay: 'hidden',
            precision: { min: 0, max: 2 },
          }"
        />
      </div>
      <div class="col-lg-8">
        <label class="mb-1">{{ $t('TMR Middle Screen %') }}</label>
        <currency-input
          v-model="assessor.data.tmr_middle_screen"
          :options="{
            currency: 'USD',
            currencyDisplay: 'hidden',
            precision: { min: 0, max: 2 },
          }"
        />
      </div>
      <div class="col-lg-8">
        <label class="mb-1">{{ $t('TMR Bottom Screen %') }}</label>
        <currency-input
          v-model="assessor.data.tmr_bottom_screen"
          :options="{
            currency: 'USD',
            currencyDisplay: 'hidden',
            precision: { min: 0, max: 2 },
          }"
        />
      </div>
      <div class="col-lg-8">
        <label class="mb-1">{{ $t('TMR Pan %') }}</label>
        <currency-input
          v-model="assessor.data.tmr_pan"
          :options="{
            currency: 'USD',
            currencyDisplay: 'hidden',
            precision: { min: 0, max: 2 },
          }"
        />
      </div>
      <div class="col-lg-8">
        <label class="mb-1">{{ $t('Rumination Time per Day (minutes)') }}</label>
        <currency-input
          v-model="assessor.data.rumination_time_per_day"
          :options="{
            currency: 'USD',
            currencyDisplay: 'hidden',
            precision: { min: 0, max: 2 },
          }"
        />
      </div>
    </div>

    <hr class="mt-4" />

    <question-three
      @change="
        assessor.data.are_feed_delivery_and_pushups_timed_to_maximize_feed_access = $event.value
      "
      :initial-value="assessor.data.are_feed_delivery_and_pushups_timed_to_maximize_feed_access"
    >
      <label class="label d-inline-block">
        {{ 'Are feed delivery and pushups timed to maximize feed access?' | translate }}
      </label>
    </question-three>

    <hr />

    <question-three
      @change="
        assessor.data.are_cows_fed_more_than_of_concentrate_grain_in_the_parlor = $event.value
      "
      :initial-value="assessor.data.are_cows_fed_more_than_of_concentrate_grain_in_the_parlor"
    >
      <label class="label d-inline-block">
        {{
          evaluationClass.isImperial
            ? 'Are cows fed more than 8 lb of concentrate/grain in the parlor?'
            : 'Are cows fed more than 3.6 kg of concentrate/grain in the parlor?' | translate
        }}
        <!-- $t('Are cows fed more than ') +
          nutritionandfeeding.getMinAreCowsFedMoreThanOfConcentrateGrainInTheParlor() +
          $t(' ') +
          $t($getEquivalentUnit(evaluation.data.measurements, 'kg')) +
          $t(' of concentrate/grain in the parlor?') + evaluationClass.isImperial -->
      </label>
    </question-three>

    <hr />

    <question-three
      @change="
        assessor.data.is_there_a_highly_fermentable_carbohydrate_feed_delivered_separate_at_any_time =
          $event.value
      "
      :initial-value="
        assessor.data.is_there_a_highly_fermentable_carbohydrate_feed_delivered_separate_at_any_time
      "
    >
      <label class="label d-inline-block">
        {{
          'Is there a highly fermentable carbohydrate feed delivered separate at any time?'
            | translate
        }}
      </label>
    </question-three>

    <hr />

    <question-three
      @change="
        assessor.data.if_rumenocentesis_has_been_performed_does_the_best_indicate_a_problem_with_sara =
          $event.value
      "
      :initial-value="
        assessor.data
          .if_rumenocentesis_has_been_performed_does_the_best_indicate_a_problem_with_sara
      "
    >
      <label class="label d-inline-block">
        {{
          'If rumenocentesis has been performed, does the test indicate a problem with SARA (Sub-Acute Ruminal Acidosis)?'
            | translate
        }}
      </label>
    </question-three>

    <hr />

    <question-three
      @change="assessor.data.is_a_complete_nutrient_workup_required = $event.value"
      :initial-value="assessor.data.is_a_complete_nutrient_workup_required"
    >
      <label class="label d-inline-block">
        {{ 'Is a complete nutrient workup required?' | translate }}
      </label>
    </question-three>

    <hr class="mb-4" />

    <div class="row mx-0 mb-3">
      <div class="col-24 pl-0">
        <h2 class="h2 mb-lg-4">{{ 'Nutrition Supply' | translate }}</h2>
      </div>

      <div class="col-lg-12">
        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1">
              {{
                $t('Dry Matter Intake (') +
                $t($getEquivalentUnit(evaluation.data.measurements, 'kg')) +
                $t('/day)')
              }}
            </label>
            <label class="mb-0 mr-2 pull-right">{{ $t('Target') }}</label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              class="form-control form-control--freestall mb-0"
              v-model="converted_dry_matter_intake"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div
            class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal"
          ></div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{
                $t('Buffer (') +
                $t($getEquivalentUnit(evaluation.data.measurements, 'g')) +
                $t('/cow/day)')
              }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              class="form-control form-control--freestall mb-0"
              v-model="converted_buffer"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{
              String(nutritionandfeeding.getMinBuffer()).replace(/^(0+)/g, '') +
              $t('-') +
              String(nutritionandfeeding.getMaxBuffer()).replace(/^(0+)/g, '')
            }}
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('Forage NDF %') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.forage_ndf"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{
              nutritionandfeeding.getMinForageNdf() +
              $t('-') +
              nutritionandfeeding.getMaxForageNdf()
            }}
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('NDF %') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.ndf"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ $t('≥') + nutritionandfeeding.getMinNdf() }}
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('NFC %') }}
            </label>
          </div>
          <div class="col-20 col-md-21 col-lg- pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.nfc"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ nutritionandfeeding.getIdealNfcMin() }}-{{ nutritionandfeeding.getIdealNfcMax() }}
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('ADF %') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.adf"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ nutritionandfeeding.getIdealAdfMin() }}-{{ nutritionandfeeding.getIdealAdfMax() }}
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('CP %') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.cp"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 px-0 d-flex justify-content-center align-items-center ideal">
            {{ nutritionandfeeding.getMinCp() | numberFormat }}-{{
              nutritionandfeeding.getMaxCp() | numberFormat
            }}
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('Ca %') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.ca"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 px-0 d-flex justify-content-center align-items-center ideal">
            {{ String(nutritionandfeeding.getMinCa()).replace(/^(0+)/g, '') | numberFormat }}-{{
              nutritionandfeeding.getMaxCa() | numberFormat
            }}
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('P %') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.p"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinP()).replace(/^(0+)/g, '') | numberFormat }}-{{
              String(nutritionandfeeding.getMaxP()).replace(/^(0+)/g, '') | numberFormat
            }}
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('K %') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.k"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ nutritionandfeeding.getMinK() | numberFormat }}-{{
              nutritionandfeeding.getMaxK() | numberFormat
            }}
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('Mg %') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.mg"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinMg()).replace(/^(0+)/g, '') | numberFormat }}-{{
              String(nutritionandfeeding.getMaxMg()).replace(/^(0+)/g, '') | numberFormat
            }}
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('S %') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.s"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinS()).replace(/^(0+)/g, '') | numberFormat }}-{{
              String(nutritionandfeeding.getMaxS()).replace(/^(0+)/g, '') | numberFormat
            }}
          </div>
        </div>

        <div class="row mb-3 mb-md-0">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('Zn ppm') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.zn_ppm"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ nutritionandfeeding.getMinZnPpm() | numberFormat }}-{{
              nutritionandfeeding.getMaxZnPpm() | numberFormat
            }}
          </div>
          <div class="col-20 col-md-21 pl-0">
            <div class="form-group mb-0 mb-sm-1 mt-3">
              <select
                :class="[
                  'form-control mb-3',
                  {
                    'is-invalid':
                      assessor.data.zn_ppm_select === null && assessor.data.zn_ppm !== null,
                  },
                ]"
                v-model="assessor.data.zn_ppm_select"
              >
                <option :value="null" disabled>
                  {{ 'Select' | translate }}
                </option>
                <option value="supplemental" selected>
                  {{ 'Supplemental' | translate }}
                </option>
                <option value="total_dietary">
                  {{ 'Total Dietary' | translate }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <!-- end left column -->

      <!-- right column -->
      <div class="offset-lg-1 col-lg-11">
        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1">
              {{ $t('Cu ppm') }}
            </label>
            <label class="mb-0 mr-2 d-none d-md-block pull-right">{{ $t('Target') }}</label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.cu_ppm"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ nutritionandfeeding.getMinCuPpm() + $t('-') + nutritionandfeeding.getMaxCuPpm() }}
          </div>
          <div class="col-20 col-md-21 pl-0">
            <div class="form-group mb-0 mb-sm-1 mt-3">
              <select
                :class="[
                  'form-control mb-0',
                  {
                    'is-invalid':
                      assessor.data.cu_ppm_select === null && assessor.data.cu_ppm !== null,
                  },
                ]"
                v-model="assessor.data.cu_ppm_select"
              >
                <option :value="null" disabled>
                  {{ 'Select' | translate }}
                </option>
                <option value="supplemental" selected>
                  {{ 'Supplemental' | translate }}
                </option>
                <option value="total_dietary">
                  {{ 'Total Dietary' | translate }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('Mn ppm') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.mn_ppm"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ nutritionandfeeding.getMinMnPpm() + $t('-') + nutritionandfeeding.getMaxMnPpm() }}
          </div>
          <div class="col-20 col-md-21 pl-0">
            <div class="form-group mb-0 mb-sm-1 mt-3">
              <select
                :class="[
                  'form-control mb-0',
                  {
                    'is-invalid':
                      assessor.data.mn_ppm_select === null && assessor.data.mn_ppm !== null,
                  },
                ]"
                v-model="assessor.data.mn_ppm_select"
              >
                <option :value="null" disabled>
                  {{ 'Select' | translate }}
                </option>
                <option value="supplemental" selected>
                  {{ 'Supplemental' | translate }}
                </option>
                <option value="total_dietary">
                  {{ 'Total Dietary' | translate }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('Co ppm') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.co_ppm"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinCoPpm()).replace(/^(0+)/g, '') | numberFormat }}-{{
              nutritionandfeeding.getMaxCoPpm() | numberFormat
            }}
          </div>
          <div class="col-20 col-md-21 pl-0">
            <div class="form-group mb-0 mb-sm-1 mt-3">
              <select class="form-control mb-0" v-model="assessor.data.co_ppm_select">
                <option :value="null" disabled>
                  {{ 'Select' | translate }}
                </option>
                <option value="supplemental">
                  {{ 'Supplemental' | translate }}
                </option>
                <option value="total_dietary">
                  {{ 'Total Dietary' | translate }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('I ppm') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.i_ppm"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinIPpm()).replace(/^(0+)/g, '') | numberFormat }}-{{
              nutritionandfeeding.getMaxIPpm() | numberFormat
            }}
          </div>
          <div class="col-20 col-md-21 pl-0">
            <div class="form-group mb-0 mb-sm-1 mt-3">
              <select class="form-control mb-0" v-model="assessor.data.i_ppm_select">
                <option :value="null" disabled>
                  {{ 'Select' | translate }}
                </option>
                <option value="supplemental">
                  {{ 'Supplemental' | translate }}
                </option>
                <option value="total_dietary">
                  {{ 'Total Dietary' | translate }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('Se ppm') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.se_ppm"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinSePpm()).replace(/^(0+)/g, '') | numberFormat }}-{{
              nutritionandfeeding.getMaxSePpm() | numberFormat
            }}
          </div>
          <div class="col-20 col-md-21 pl-0">
            <div class="form-group mb-0 mb-sm-1 mt-3">
              <select class="form-control mb-0" v-model="assessor.data.se_ppm_select">
                <option :value="null" disabled>
                  {{ 'Select' | translate }}
                </option>
                <option value="supplemental">
                  {{ 'Supplemental' | translate }}
                </option>
                <option value="total_dietary">
                  {{ 'Total Dietary' | translate }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('Fe ppm') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.fe_ppm"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div
            class="col-4 col-md-3 px-0 col-md-3 d-flex justify-content-center align-items-center ideal"
          >
            {{ nutritionandfeeding.getMinFePpm() + $t('-') + nutritionandfeeding.getMaxFePpm() }}
          </div>
          <div class="col-20 col-md-21 pl-0">
            <div class="form-group mb-0 mb-sm-1 mt-3">
              <select class="form-control mb-0" v-model="assessor.data.fe_ppm_select">
                <option :value="null" disabled>
                  {{ 'Select' | translate }}
                </option>
                <option value="supplemental">
                  {{ 'Supplemental' | translate }}
                </option>
                <option value="total_dietary">
                  {{ 'Total Dietary' | translate }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('Mo ppm') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.mo_ppm"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            <!-- {{ $t(">6:1") }} -->
          </div>
        </div>

        <div class="row">
          <div class="col-20 pl-0">
            <label class="mb-0 mt-3 mr-1">
              {{ $t('Biotin') + ' (' + $t('mg') + $t('/d)') }}
              <!-- $getEquivalentUnit(evaluation.data.measurements,'mg') -->
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.biotin"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ nutritionandfeeding.getMinBiotin() }}
          </div>
        </div>
      </div>
      <!-- end right column -->
    </div>
    <!-- end nutrition supply -->

    <hr class="my-4" />

    <div class="row mx-0 mb-3">
      <div class="col-24 pl-0">
        <h2 class="h2 mb-lg-4">
          {{ $t('Zinpro Performance Minerals') + ' (' + $t('g') + ')' }}
        </h2>
      </div>

      <div class="col-lg-12">
        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('Zinpro 4-Plex C') }}
            </label>
            <label class="mb-0 mr-2 pull-right">{{ $t('Target') }}</label>
          </div>

          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_4_plex_c"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMin4PlexC()) | numberFormat }}
          </div>
        </div>

        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('Zinpro Availa 4') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_availa_4"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinAvaila4()) | numberFormat }}
          </div>
        </div>

        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('Zinpro Propath Cu') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_availa_cu_100"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 px-0 d-flex justify-content-center align-items-center ideal">
            {{ String(nutritionandfeeding.getMinAvailaCu100()) | numberFormat }}
          </div>
        </div>

        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('Zinpro Availa Mn 80') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_availa_mn_80"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinAvailaMn80()) | numberFormat }}
          </div>
        </div>

        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('Zinpro Availa Zn 120') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_availa_zn_120"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinAvailaZn120()) | numberFormat }}
          </div>
        </div>

        <div class="row mb-3 mb-md-0">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('Zinpro Availa Plus') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_availa_plus"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinAvailaPlus()) | numberFormat }}
          </div>
        </div>

        <div class="row mb-3 mb-md-0">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('Availa Dairy') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="assessor.data.availa_dairy"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinAvailaDairy()) | numberFormat }}
          </div>
        </div>
      </div>

      <div class="offset-lg-1 col-lg-11">
        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('Zinpro COPRO 25') }}
            </label>
            <label class="mb-0 mr-2 d-none d-md-block pull-right">{{ $t('Target') }}</label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_copro_25"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 px-0 d-flex justify-content-center align-items-center ideal">
            {{ String(nutritionandfeeding.getMinCopro25()) | numberFormat }}
          </div>
        </div>

        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('CuPlex 100') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_cuplex_100"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 px-0 d-flex justify-content-center align-items-center ideal">
            {{ String(nutritionandfeeding.getMinCuplex100()) | numberFormat }}
          </div>
        </div>

        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('CuPlex 50') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_cuplex_50"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 px-0 d-flex justify-content-center align-items-center ideal">
            {{ String(nutritionandfeeding.getMinCuplex50()) | numberFormat }}
          </div>
        </div>

        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('Zinpro 120') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_zinpro_120"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinZinpro120()) | numberFormat }}
          </div>
        </div>

        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('Zinpro 180') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_zinpro_180"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinZinpro180()) | numberFormat }}
          </div>
        </div>

        <div class="row">
          <div class="col-24 pl-0 pr-1">
            <label class="mb-0 mr-1 mt-3">
              {{ $t('Zinpro 40') }}
            </label>
          </div>
          <div class="col-20 col-md-21 pl-0 stall d-flex align-items-center">
            <currency-input
              v-model="converted_zinpro_40"
              :options="{
                currency: 'USD',
                currencyDisplay: 'hidden',
                precision: { min: 0, max: 2 },
              }"
            />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center px-0 ideal">
            {{ String(nutritionandfeeding.getMinZinpro40()) | numberFormat }}
          </div>
        </div>
      </div>
      <!-- end right column -->
    </div>
    <!-- end Zinpro Performance Minerals -->

    <hr class="mt-4" />

    <div class="row my-0">
      <div class="col-md-12">
        <personal-notes v-model="assessor.data.personal_notes"></personal-notes>
      </div>
      <div class="col-md-12">
        <presentation-notes v-model="assessor.data.presentation_notes"></presentation-notes>
      </div>
    </div>

    <div
      class="row mx-0 justify-content-center justify-content-md-start center align-items-center pb-0 mt-4"
    >
      <photoUpload :assessorId="14" :assessor="assessor"></photoUpload>
    </div>

    <hr class="mb-3 mb-md-5 mt-3 mt-md-5" />

    <div class="row misc-bottom">
      <div class="col-md-12 flex-sm-row-reverse">
        <a class="btn btn-secondary btn-full--sm mb-2 mt-md-0" href="javascript:history.go(-1)">{{
          'Back' | translate
        }}</a>
      </div>
      <div class="col-md-12">
        <router-link
          v-if="user && user.role !== 'data_entry'"
          :to="'/reports'"
          class="btn btn-primary btn-full--sm pull-right"
        >
          {{ 'Reports' | translate }}
        </router-link>
        <button
          v-else-if="user && user.role === 'data_entry' && !$store.state.offline"
          data-toggle="modal"
          @click="requestReport(evaluation.name)"
          :data-target="['#requestSent-' + user.id]"
          class="btn btn-primary btn-full--sm pull-right"
        >
          {{ 'Request Report' | translate }}
          <span v-show="requestReportLoader" class="loader ml-1"></span>
        </button>
      </div>
    </div>

    <div v-show="successMessage" class="alert alert-primary mt-3 mb-0" role="alert">
      {{ 'Your request has been sent!' | translate }}
    </div>

    <div v-show="errorMessage" class="alert alert-danger mt-3 mb-0" role="alert">
      {{ 'An error has occurred during your request!' | translate }}
    </div>
  </div>
  <!-- end container -->
</template>

<script>
import _ from 'lodash';
import PresentationNotes from '@/pages/assessors/assessor_components/presentation-notes';
import PersonalNotes from '@/pages/assessors/assessor_components/personal-notes';
import Question from '@/pages/assessors/assessor_components/question';
import QuestionThree from '@/pages/assessors/assessor_components/question-three';
import ModalInfo from '@/components/misc/modal-info';
import PhotoUpload from '@/components/misc/photoUpload';
import HygieneHeader from '@/pages/assessors/assessor_components/hygiene-header';
import convert from 'convert-units';
import NutritionAndFeeding from '@/libs/Classes/NutritionAndFeeding.js';
import Evaluation from '@/libs/Classes/Evaluation.js';
import Group from '@/libs/Classes/Group.js';
import requestReportMixin from '@/mixins/requestReport.js';
import CurrencyInput from '@/components/common/CurrencyInput.vue';

export default {
  components: {
    PersonalNotes,
    PresentationNotes,
    Question,
    QuestionThree,
    HygieneHeader,
    PhotoUpload,
    ModalInfo,
    CurrencyInput,
  },
  props: ['assessor', 'group', 'evaluation'],

  mixins: [requestReportMixin],

  data() {
    return {
      nutritionandfeeding: null,
      evaluationClass: null,
    };
  },
  created() {
    this.evaluationClass = new Evaluation(this, this.evaluation);
    let groupClass = new Group(this, this.evaluationClass, this.group);
    this.nutritionandfeeding = new NutritionAndFeeding(
      this,
      this.evaluationClass,
      groupClass,
      this.assessor,
    );
  },
  computed: {
    converted_feed_space: {
      get: function () {
        return this.nutritionandfeeding !== null ? this.nutritionandfeeding.getFeedSpace(0) : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setFeedSpace(newValue);
      },
    },
    converted_dry_matter_intake: {
      get: function () {
        return this.assessor.data.dry_matter_intake;
      },
      set: function (newValue) {
        this.assessor.data.dry_matter_intake = newValue;
      },
    },
    converted_buffer: {
      get: function () {
        return this.nutritionandfeeding !== null ? this.nutritionandfeeding.getBuffer(0) : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setBuffer(newValue);
      },
    },
    converted_4_plex_c: {
      get: function () {
        return this.nutritionandfeeding !== null ? this.nutritionandfeeding.get4PlexC() : 0;
      },
      set: function (newValue) {
        this.nutritionandfeeding.set4PlexC(newValue);
      },
    },
    converted_availa_4: {
      get: function () {
        return this.nutritionandfeeding !== null ? this.nutritionandfeeding.getAvaila4(0) : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setAvaila4(newValue);
      },
    },
    converted_availa_cu_100: {
      get: function () {
        return this.nutritionandfeeding !== null
          ? this.nutritionandfeeding.getAvailaCu100(0)
          : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setAvailaCu100(newValue);
      },
    },
    converted_availa_mn_80: {
      get: function () {
        return this.nutritionandfeeding !== null
          ? this.nutritionandfeeding.getAvailaMn80(0)
          : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setAvailaMn80(newValue);
      },
    },
    converted_availa_zn_120: {
      get: function () {
        return this.nutritionandfeeding !== null
          ? this.nutritionandfeeding.getAvailaZn120(0)
          : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setAvailaZn120(newValue);
      },
    },
    converted_availa_zn_40: {
      get: function () {
        return this.nutritionandfeeding !== null
          ? this.nutritionandfeeding.getAvailaZn40(0)
          : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setAvailaZn40(newValue);
      },
    },
    converted_availa_plus: {
      get: function () {
        return this.nutritionandfeeding !== null
          ? this.nutritionandfeeding.getAvailaPlus(0)
          : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setAvailaPlus(newValue);
      },
    },
    converted_copro_25: {
      get: function () {
        return this.nutritionandfeeding !== null ? this.nutritionandfeeding.getCopro25(0) : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setCopro25(newValue);
      },
    },
    converted_cuplex_100: {
      get: function () {
        return this.nutritionandfeeding !== null ? this.nutritionandfeeding.getCuplex100(0) : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setCuplex100(newValue);
      },
    },
    converted_cuplex_50: {
      get: function () {
        return this.nutritionandfeeding !== null ? this.nutritionandfeeding.getCuplex50(0) : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setCuplex50(newValue);
      },
    },
    converted_zinpro_120: {
      get: function () {
        return this.nutritionandfeeding !== null ? this.nutritionandfeeding.getZinpro120(0) : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setZinpro120(newValue);
      },
    },
    converted_zinpro_180: {
      get: function () {
        return this.nutritionandfeeding !== null ? this.nutritionandfeeding.getZinpro180(0) : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setZinpro180(newValue);
      },
    },
    converted_zinpro_40: {
      get: function () {
        return this.nutritionandfeeding !== null ? this.nutritionandfeeding.getZinpro40(0) : false;
      },
      set: function (newValue) {
        return this.nutritionandfeeding.setZinpro40(newValue);
      },
    },
  },
  watch: {
    'assessor.data.percentage_of_group_lying_down_chewing_cud': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.percentage_of_group_lying_down_chewing_cud = null;
          } else if (newVal > 100) {
            this.assessor.data.percentage_of_group_lying_down_chewing_cud = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.dry_matter': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.dry_matter = null;
          } else if (newVal > 100) {
            this.assessor.data.dry_matter = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.tmr_top_screen': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.tmr_top_screen = null;
          } else if (newVal > 100) {
            this.assessor.data.tmr_top_screen = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.tmr_middle_screen': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.tmr_middle_screen = null;
          } else if (newVal > 100) {
            this.assessor.data.tmr_middle_screen = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.tmr_bottom_screen': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.tmr_bottom_screen = null;
          } else if (newVal > 100) {
            this.assessor.data.tmr_bottom_screen = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.tmr_pan': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.tmr_pan = null;
          } else if (newVal > 100) {
            this.assessor.data.tmr_pan = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.forage_ndf': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.forage_ndf = null;
          } else if (newVal > 100) {
            this.assessor.data.forage_ndf = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.ndf': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.ndf = null;
          } else if (newVal > 100) {
            this.assessor.data.ndf = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.nfc': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.nfc = null;
          } else if (newVal > 100) {
            this.assessor.data.nfc = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.adf': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.adf = null;
          } else if (newVal > 100) {
            this.assessor.data.adf = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.cp': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.cp = null;
          } else if (newVal > 100) {
            this.assessor.data.cp = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.ca': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.ca = null;
          } else if (newVal > 100) {
            this.assessor.data.ca = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.p': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.p = null;
          } else if (newVal > 100) {
            this.assessor.data.p = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.k': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.k = null;
          } else if (newVal > 100) {
            this.assessor.data.k = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.mg': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.mg = null;
          } else if (newVal > 100) {
            this.assessor.data.mg = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.s': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.s = null;
          } else if (newVal > 100) {
            this.assessor.data.s = 100;
          }
        });
      },
      immediate: true,
    },
  },
};
</script>
    'assessor.data.k': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.k = null;
          } else if (newVal > 100) {
            this.assessor.data.k = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.mg': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.mg = null;
          } else if (newVal > 100) {
            this.assessor.data.mg = 100;
          }
        });
      },
      immediate: true,
    },
    'assessor.data.s': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return;
        this.$nextTick(() => {
          if (newVal < 0) {
            this.assessor.data.s = null;
          } else if (newVal > 100) {
            this.assessor.data.s = 100;
          }
        });
      },
      immediate: true,
    },
  },
};
</script>
